module.exports = {
      id: "mynews-usage",
      viewBox: "0 0 13.581 13.581",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#mynews",
      toString: function () {
        return this.url;
      }
    }